export let estimateForm = $state(
	storageAvailable('localStorage') && localStorage.getItem('estimateForm')
		? JSON.parse(localStorage.getItem('estimateForm'))
		: { data: {} },
);

export function storageAvailable(type) {
	let storage;
	try {
		storage = window[type];
		const x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return (
			e instanceof DOMException &&
			e.name === 'QuotaExceededError' &&
			// acknowledge QuotaExceededError only if there's something already stored
			storage &&
			storage.length !== 0
		);
	}
}

export function selectDefaultNameOnFocus(event) {
	const target = event?.target;
	const defaultRoomWindowPattern = /^(Room|Window) \d+$/;
	if (
		target &&
		typeof target.value === 'string' &&
		defaultRoomWindowPattern.test(target.value)
	) {
		//target.select(); // <--
		target.value = '';
		target.dispatchEvent(new Event('input', { bubbles: true }));
	}
}
